import { useEffect } from 'react';

const GoogleAnalytics = () => {
  const measurementId = import.meta.env.VITE_GA4_MEASUREMENT_ID;

  useEffect(() => {
    if (!measurementId || !import.meta.env.PROD) return;
    if (measurementId === 'G-XXXXXXXXXX') return;
    if (document.querySelector(`script[src*="${measurementId}"]`)) return;

    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.async = true;
    document.head.appendChild(script);

    (window as any).dataLayer = (window as any).dataLayer || [];
    function gtag(...args: any[]) { (window as any).dataLayer.push(args); }
    (window as any).gtag = gtag;
    gtag('js', new Date());
    gtag('config', measurementId, { anonymize_ip: true });
  }, [measurementId]);

  return null;
};

export default GoogleAnalytics;
